import { render, staticRenderFns } from "./BookOrder1.vue?vue&type=template&id=62d21a43&scoped=true"
import script from "./BookOrder1.vue?vue&type=script&lang=js"
export * from "./BookOrder1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d21a43",
  null
  
)

export default component.exports